import React from "react";
import { CustomIcon } from "../shared/CustomIcon";

// =============================================================
// OccupancyLogPanel — modal showing full history of one slot.
// Reads `node.occupancyLog` (server pre-masks sensitive reasons
// for Limited Admin — we render whatever the server returns).
// =============================================================
export default function OccupancyLogPanel({ node, onClose }) {
  if (!node) return null;
  const log = node.occupancyLog || [];
  return (
    <div
      data-testid="occupancy-log-panel"
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "var(--kc-surface)", border: "1px solid color-mix(in srgb, var(--kc-accent) 30%, transparent)", borderRadius: 12, padding: 20, maxWidth: 560, width: "100%", maxHeight: "88vh", overflowY: "auto" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div>
            <div style={{ fontFamily: "'Cinzel',serif", fontSize: 18, fontWeight: 700, color: "var(--kc-accent)" }}>{node.slotRef}</div>
            <div style={{ fontSize: 12, color: "var(--kc-sub)" }}>{node.levelName} · Level {node.level} · {log.length} entries</div>
          </div>
          <button onClick={onClose} data-testid="occupancy-close" style={{ background: "transparent", border: "1px solid color-mix(in srgb, var(--kc-accent) 30%, transparent)", color: "var(--kc-accent)", borderRadius: 8, padding: "6px 12px", cursor: "pointer" }}>Close</button>
        </div>
        {log.length === 0 ? (
          <div style={{ padding: 24, textAlign: "center", color: "var(--kc-sub)", fontFamily: "'Montserrat',sans-serif" }}>
            No occupancy history yet.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {log.map((e, idx) => {
              const active = !e.dateDeparted;
              return (
                <div
                  key={idx}
                  data-testid={`occupancy-entry-${idx}`}
                  style={{
                    background: active ? "rgba(74,222,128,0.08)" : "rgba(255,255,255,0.03)",
                    border: `1px solid ${active ? "rgba(74,222,128,0.30)" : "rgba(255,255,255,0.08)"}`,
                    borderRadius: 10, padding: 12,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    {e.memberPhoto ? (
                      <img src={e.memberPhoto} alt="" style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }} />
                    ) : (
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#333", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11 }}>
                        <CustomIcon name="person" size={14} />
                      </div>
                    )}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--kc-text)" }}>{e.memberName}</div>
                      <div style={{ fontSize: 11, color: "var(--kc-accent)", fontFamily: "'Cinzel',serif" }}>#{e.memberNumber}</div>
                    </div>
                    {active && (
                      <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", padding: "2px 8px", borderRadius: 999, color: "#4ade80", border: "1px solid rgba(74,222,128,0.40)" }}>
                        Current
                      </span>
                    )}
                  </div>
                  <div style={{ marginTop: 8, fontSize: 11, color: "var(--kc-sub)", display: "flex", flexDirection: "column", gap: 3 }}>
                    <div>Assigned: {(e.dateAssigned || "").slice(0, 10)}</div>
                    {e.dateDeparted && <div>Departed: {(e.dateDeparted || "").slice(0, 10)}</div>}
                    {e.departureReason && <div>Reason: <strong style={{ color: "var(--kc-text)" }}>{e.departureReason}</strong></div>}
                    {e.departureNotes && <div>Notes: {e.departureNotes}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
